import apiService from '@sonifi/wb-core/services/api.service';
import { setLatestSynchronizeJob } from '../../store/settings/guestRequestSettingsSlice';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import { setAlert } from '@sonifi/wb-notifier/store/notifierSlice';

export const getLatestImportJob = async (groupId) => {
  try {
    const params = {
      _order_by: '-created',
      'arguments.group': `/groups/${groupId}`,
      rpp: 1,
      status: 'COMPLETED_SUCCESSFULLY',
      type: 'GUEST_REQUEST_VENDOR_MAP_IMPORT',
    };
    const url = `${ENDPOINTS.JOBS}?${parseQueryParams(params)}`;
    const latestImportJobRes = await apiService.get(url);
    const latestImportJob = latestImportJobRes.data.objects.length
      ? latestImportJobRes.data.objects[0]
      : null;
    return latestImportJob;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getLatestSynchronizeJob = async (group) => {
  try {
    const params = {
      _order_by: '-created',
      'arguments.cms_id': group.cms_id,
      rpp: 1,
      type: 'GUEST_REQUEST_STRUCTURE_SYNCHRONIZE',
    };
    const url = `${ENDPOINTS.JOBS}?${parseQueryParams(params)}`;
    const latestSynchronizeJobRes = await apiService.get(url);
    const latestSynchronizeJob = latestSynchronizeJobRes.data.objects.length
      ? latestSynchronizeJobRes.data.objects[0]
      : null;
    return latestSynchronizeJob;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const saveGuestRequestJobs = async ({ file, groupId }) => {
  try {
    const body = {
      arguments: {
        filename: file.title,
        group: `/groups/${groupId}`,
        overwrite_all: true,
      },
      targets: [file.uri],
      type: 'GUEST_REQUEST_VENDOR_MAP_IMPORT',
    };
    await apiService.post(ENDPOINTS.JOBS, body);
    return true;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const triggerSynchronization = () => async (dispatch, getState) => {
  try {
    const {
      groups: { selectedGroup },
    } = getState();
    const body = {
      type: 'GUEST_REQUEST_STRUCTURE_SYNCHRONIZE',
      targets: [`/groups/${selectedGroup.id}`],
    };

    const res = await apiService.post(ENDPOINTS.JOBS, body);
    const latestSynchronizeJob = res.data;
    dispatch(setLatestSynchronizeJob(latestSynchronizeJob));
  } catch (error) {
    console.error(error);
    dispatch(
      setAlert({
        content: 'There was an error synchronizing. Please try again later.',
        type: 'danger',
        show: true,
        dismissable: true,
      }),
    );
    return Promise.reject(error);
  }
};
